import { BRAND_PILL, initialsOf } from "./agents.helpers";

export const BRAND_OPTIONS = [
  "petnsur",
  "autolife",
  "broadlands",
  "beneficial",
] as const;

export function BrandPill({ brand }: { brand: string }) {
  const cls = BRAND_PILL[brand] ?? BRAND_PILL.unknown;
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}
    >
      {brand || "unknown"}
    </span>
  );
}

export function AgentAvatar({
  name,
  email,
}: {
  name: string | null;
  email: string | null;
}) {
  return (
    <div className="h-8 w-8 rounded-full bg-secondary/15 text-secondary text-xs font-medium flex items-center justify-center shrink-0">
      {initialsOf(name, email)}
    </div>
  );
}
